import { requestProcessCallDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const requestProcessCallCallable = getCallable(
  requestProcessCallDefinition,
);
